import { Routes } from '@angular/router';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout/auth-layout.component';
import { LoginComponent } from './pages/login/login/login.component';
import { MainLayoutComponent } from './layouts/main-layout/main-layout/main-layout.component';
import { DashboardComponent } from './pages/dashboard/dashboard/dashboard.component';
import { authGuard } from '@share';
//import { SampleFormComponent } from './pages/sample-form/sample-form.component';
import { MarketPriceComponent } from './pages/market-price/market-price.component';
//import { TestComponent } from './pages/test/test.component';
//import { QuizComponent } from './pages/quiz-sample/quiz.component';
import { GroupComponent } from './pages/group/group.component';
import { CategoryComponent } from './pages/category/category.component';
import { SubcategoryComponent } from './pages/subcategory/subcategory.component';
import { UserComponent } from './pages/user/user.component';
import { RoleComponent } from './pages/role/role.component';
import { AdminUserComponent } from './pages/admin-user/admin-user.component';
import { PermissionGuard } from './share/services/permission-guard.service';
import { ForbiddenComponent } from './pages/forbidden/forbidden.component';
import { ItemComponent } from './pages/item/item.component';
import { PostComponent } from './pages/post/post.component';
import { QuizBuilderComponent } from './pages/quiz-builder/quiz-builder.component';
import { QuizListComponent } from './pages/quiz-list/quiz-list.component';
import { ItemPriceComponent } from './pages/item-price/item-price.component';
import { PriceChangeHistoryComponent } from './pages/price-change-history/price-change-history.component';
import { PriceChangeDateComponent } from './pages/price-change-date/price-change-date.component';
import { ItemMetricComponent } from './pages/item-metric/item-metric.component';
//import { ItemCategoryComponent } from './pages/item-category/item-category.component';
import { MainCategoryComponent } from './pages/main-category/main-category.component';
import { AppAlertComponent } from './pages/app-alert/app-alert.component';
import { SurveyComponent } from './pages/survey/survey.component';
import { PostTitleComponent } from './pages/post-title/post-title.component';
import { BizPostComponent } from './pages/biz-post/biz-post.component';
import { QuizResultComponent } from './pages/quiz-result/quiz-result.component';
import { AdminPostComponent } from './pages/admin-post/admin-post.component';
//import { QuizBuilderComponent } from './pages/quesion-builder/quiz-builder.component';
export const routes: Routes = [
    {
        path: '',
        redirectTo: '/dashboard',
        pathMatch: 'full', // Ensures an exact match for redirection

    },
    
    {
        path: 'auth',
        component: AuthLayoutComponent,
        children: [
            {
                path: 'login',
                component: LoginComponent
            },
            {
                path: 'forbidden',
                component:ForbiddenComponent
            },

        ]
    },
    {
        path: '',
        component: MainLayoutComponent,
        canActivate: [authGuard], // Protect the main layout with the guard
        children: [
            {
                path: 'dashboard',
                component: DashboardComponent,
                canActivate: [PermissionGuard], data: { permissions: ['dashboard.view'], title: 'Dashboard' }
            },
            
            // {
            //     path: 'form/sample',
            //     component: SampleFormComponent,
            //     canActivate: [PermissionGuard], data: { permissions: ['sample.view'] }
            // },
            {
                path: 'form/marketprice',
                component: MarketPriceComponent,
                canActivate: [PermissionGuard], data: { permissions: ['marketprice.view'] }
            },
            // {
            //     path: 'test',
            //     component: TestComponent,
            //     canActivate: [PermissionGuard], data: { permissions: ['test.view'] }
            // },
            {
                path: 'quizlist/quiz',
                component: QuizBuilderComponent,
                canActivate: [PermissionGuard], data: { permissions: ['createquiz.view'] }
            },
            {
                path: 'quizlist/quiz/:id',
                component: QuizBuilderComponent,
                canActivate: [PermissionGuard], data: { permissions: ['createquiz.view'] }
            },
            {
                path: 'quizlist',
                component: QuizListComponent,
                canActivate: [PermissionGuard], data: { permissions: ['quizlist.view'] }
            },
            {
                path: 'group',
                component: GroupComponent,
                canActivate: [PermissionGuard], data: { permissions: ['group.view'] }
            },
            {
                path: 'maincategory',
                component: MainCategoryComponent,
                canActivate: [PermissionGuard], data: { permissions: ['maincategory.view'] }
            },
            
            {
                path: 'category',
                component: CategoryComponent,
                canActivate: [PermissionGuard], data: { permissions: ['category.view'] }
            },
            {
                path: 'subcategory',
                component: SubcategoryComponent,
                canActivate: [PermissionGuard], data: { permissions: ['subcategory.view'] }
            },
            {
                path: 'admin',
                component: AdminUserComponent,
                canActivate: [PermissionGuard], data: { permissions: ['admin.view'] }
            },
            {
                path: 'user',
                component: UserComponent,
                canActivate: [PermissionGuard], data: { permissions: ['user.view'] }
            },
            {
                path: 'role',
                component: RoleComponent,
                canActivate: [PermissionGuard], data: { permissions: ['role.view'] }
            },
            {
                path: 'item',
                component: ItemComponent,
                canActivate: [PermissionGuard], data: { permissions: ['item.view'] }
            },
            {
                path: 'price',
                component: ItemPriceComponent,
                canActivate: [PermissionGuard], data: { permissions: ['price.view'] }
            },
            {
                path: 'pricechange/:id',
                component: PriceChangeHistoryComponent,
                canActivate: [PermissionGuard], data: { permissions: ['pricechange.view'] }
            },
            {
                path: 'pricechange',
                component: PriceChangeHistoryComponent,
                canActivate: [PermissionGuard], data: { permissions: ['pricechange.view'] }
            },
            {
                path: 'pricechangedate',
                component: PriceChangeDateComponent,
                canActivate: [PermissionGuard], data: { permissions: ['pricechangedate.view'] }
            },
            {
                path: 'post',
                component: PostComponent,
                canActivate: [PermissionGuard], data: { permissions: ['post.view'] }
            },
            {
                path: 'itemmetric',
                component: ItemMetricComponent,
                canActivate: [PermissionGuard], data: { permissions: ['itemmetric.view'] }
            },
            {
                path: 'alert',
                component: AppAlertComponent,
                canActivate: [PermissionGuard], data: { permissions: ['weatherAlert.view'] }
            },
            {
                path: 'survey',
                component: SurveyComponent,
                canActivate: [PermissionGuard], data: { permissions: ['survey.view'] }
            },
            {
                path: 'posttitle',
                component: PostTitleComponent,
                canActivate: [PermissionGuard], data: { permissions: ['posttitle.view'] }
            },
            {
                path: 'bizpost',
                component: BizPostComponent,
                canActivate: [PermissionGuard], data: { permissions: ['bizpost.view'] }
            },
            {
                path: 'adminpost',
                component: AdminPostComponent,
                canActivate: [PermissionGuard], data: { permissions: ['adminpost.view'] }
            },
            {
                path: 'quizresult',
                component: QuizResultComponent,
                canActivate: [PermissionGuard], data: { permissions: ['role.view'] }
            }
        ]
    },
    {
        path: '**',
        redirectTo: 'auth/login' // Fallback route
    }
];
